import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import BusinessCalculator from "./pages/BusinessCalculator";
import LearnScience from "./pages/LearnScience";
import LifestylePage from "./pages/LifestylePage";
import WeddingCalculator from "./pages/WeddingCalculator";
import PetCalculator from "./pages/PetCalculator";
import FashionCalculator from "./pages/FashionCalculator";
import DigitalCalculator from "./pages/DigitalCalculator";
import StudentCalculator from "./pages/StudentCalculator";

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Navigation />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/business" element={<BusinessCalculator />} />
            <Route path="/science" element={<LearnScience />} />
            <Route path="/lifestyle" element={<LifestylePage />} />
            <Route path="/wedding" element={<WeddingCalculator />} />
            <Route path="/pet" element={<PetCalculator />} />
            <Route path="/fashion" element={<FashionCalculator />} />
            <Route path="/digital" element={<DigitalCalculator />} />
            <Route path="/student" element={<StudentCalculator />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
